// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PK1a","buttons":"Footer_buttons__13gXu"};